export default "__VITE_ASSET__BsfWdJmz__"